import React from "react";
import Drawer from "../../../common/Drawer/AgentListDrawerModal";
import { Heading } from "../../../../styles/component/style";
import PassiveNeutralsDrawer from "../../AgentListModal/PassiveNeutralsDrawer";
import {
  Header,
  ImageWrapper,
  AccordionContainer,
} from "../../AgentListModal/PassiveNeutralsDrawer";

const Index = ({
  opendrawer,
  setOpenDrawer,
  MTRef,
  partyList,
  displayAuthUrl,
  caseDetails,
  setRefreshDetails,
  viewOnly,
}) => {
  return (
    <Drawer state={opendrawer} setState={setOpenDrawer} label="Drawer">
      <Table
        {...{
          setOpenDrawer,
          MTRef,
          displayAuthUrl,
          caseDetails,
          setRefreshDetails,
          viewOnly,
        }}
        data={partyList}
      />
    </Drawer>
  );
};

export default Index;

const Table = ({
  setOpenDrawer,
  MTRef,
  data,
  displayAuthUrl,
  caseDetails,
  setRefreshDetails,
  viewOnly,
}) => {
  return (
    <div>
      <Header>
        <Heading style={{ marginBottom: "unset" }}>Agent Details</Heading>
        <ImageWrapper>
          <img
            src={require("../../../../assets/images/closeModal.svg")}
            onClick={() => setOpenDrawer(false)}
            alt="close"
          />
        </ImageWrapper>
      </Header>
      <AccordionContainer>
        {caseDetails?.resolutionKind
          ? caseDetails?.resolutionKind !== "negotiation" && (
              <PassiveNeutralsDrawer
                {...{ setOpenDrawer, caseDetails, setRefreshDetails, viewOnly }}
                id={caseDetails?.id}
              />
            )
          : null}
      </AccordionContainer>
    </div>
  );
};
